module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.2 99.2"><path class="st0" d="M50.3 15.9C68.9 15.9 84 31.1 84 50S68.8 84.1 50.3 84.1 16.6 68.8 16.6 50s15.2-34.1 33.7-34.1" fill="none" stroke="#fff" stroke-width="6" stroke-miterlimit="10"/><path class="st1" d="M50.3 25.1c13.5 0 24.5 11.1 24.5 24.7s-11 24.7-24.5 24.7-24.5-11.1-24.5-24.7 11-24.7 24.5-24.7" fill="#5a51a2"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dot.svg
// module id = 516
// module chunks = 1